import { DocumentRoles } from '@hcs/types';

import { DOCUMENT_ROLE_REPORT_FEATURES } from '../../constants/reportFeatureConfigs.constants';
import { SUBJECT_PHOTO_CARD_FEATURES } from '../SubjectPhotoCard/subjectPhotoCard.constants';

export const SUBJECT_MAP_BANNER_FEATURES = [
  ...SUBJECT_PHOTO_CARD_FEATURES,
  ...(DOCUMENT_ROLE_REPORT_FEATURES[DocumentRoles.Subject] || []),
];
